// ✅ KORRIGIERTE SHOPIFY VERSION - Größenrechner für Seamone
// Basiert auf dem funktionierenden HTML-Code mit korrekter Toleranz-Logik

console.log("✅ KORRIGIERTE SHOPIFY VERSION GELADEN - TOLERANZ-LOGIK GEFIXT!");

// EXAKTE TABELLEN AUS DEM FUNKTIONIERENDEN CODE
const WOMEN_SIZES = [
    { eu: 32, bust: 82, waist: 66, hip: 91 },
    { eu: 34, bust: 85, waist: 69, hip: 94 },
    { eu: 36, bust: 88, waist: 72, hip: 97 },
    { eu: 38, bust: 92, waist: 76, hip: 101 },
    { eu: 40, bust: 96, waist: 80, hip: 105 },
    { eu: 42, bust: 100, waist: 84, hip: 109 },
    { eu: 44, bust: 106, waist: 90.5, hip: 115 },
    { eu: 46, bust: 112, waist: 97, hip: 120 },
    { eu: 48, bust: 118, waist: 104, hip: 126 },
    { eu: 50, bust: 124, waist: 110, hip: 131 },
    { eu: 52, bust: 130, waist: 116, hip: 136 },
    { eu: 54, bust: 138, waist: 125, hip: 143.5 },
    { eu: 56, bust: 146, waist: 133.5, hip: 150.5 },
    { eu: 58, bust: 154, waist: 142, hip: 157.5 },
    { eu: 60, bust: 162, waist: 150.2, hip: 164.5 },
    { eu: 62, bust: 170, waist: 159, hip: 171.5 }
];

const MEN_SIZES = [
    { eu: 44, bust: 88, waist: 80, hip: 95 },
    { eu: 46, bust: 92, waist: 84, hip: 98 },
    { eu: 48, bust: 96, waist: 88, hip: 101 },
    { eu: 50, bust: 100, waist: 92, hip: 104 },
    { eu: 52, bust: 104, waist: 96.5, hip: 108 },
    { eu: 54, bust: 108, waist: 101, hip: 111 },
    { eu: 56, bust: 112, waist: 106, hip: 115 },
    { eu: 58, bust: 116, waist: 110, hip: 118 },
    { eu: 60, bust: 120, waist: 115, hip: 122 },
    { eu: 62, bust: 124, waist: 119, hip: 125 },
    { eu: 64, bust: 128, waist: 124, hip: 129 },
    { eu: 66, bust: 136, waist: 128, hip: 132 },
    { eu: 68, bust: 141, waist: 134, hip: 136 },
    { eu: 70, bust: 146, waist: 141, hip: 140 },
    { eu: 72, bust: 151, waist: 147, hip: 144 },
    { eu: 74, bust: 157, waist: 152, hip: 148 }
];

const KIDS_SIZES = [
    { eu: 74, bust: 48, waist: 47.6, hip: 49, height: 74 },
    { eu: 80, bust: 50, waist: 49, hip: 51, height: 80 },
    { eu: 86, bust: 51.5, waist: 50, hip: 53, height: 86 },
    { eu: 92, bust: 53, waist: 51, hip: 55, height: 92 },
    { eu: 98, bust: 54.5, waist: 52, hip: 57, height: 98 },
    { eu: 104, bust: 56, waist: 53, hip: 59, height: 104 },
    { eu: 110, bust: 60, waist: 54, hip: 59, height: 110 },
    { eu: 116, bust: 62, waist: 55, hip: 61, height: 116 },
    { eu: 122, bust: 65, waist: 57, hip: 64, height: 122 },
    { eu: 128, bust: 67, waist: 58.5, hip: 67, height: 128 },
    { eu: 134, bust: 70, waist: 60, hip: 70, height: 134 },
    { eu: 140, bust: 72, waist: 62, hip: 73, height: 140 },
    { eu: 146, bust: 75, waist: 65, hip: 76.5, height: 146 },
    { eu: 152, bust: 78, waist: 68, hip: 80, height: 152 },
    { eu: 158, bust: 81, waist: 71, hip: 83.5, height: 158 },
    { eu: 164, bust: 84, waist: 74, hip: 87, height: 164 },
    { eu: 170, bust: 87, waist: 77, hip: 90.5, height: 170 }
];

// Global variables
let currentCategory = 'women';
let measurements = {}; // Global für 2-Größen-Regel

// ===== SHOPIFY MODAL FUNKTIONEN =====
function openSizeCalculator() {
    const modal = document.getElementById('sizeCalculatorModal');
    if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
        initializeCalculator(); // Initialisierung beim Öffnen
    }
}

function closeSizeCalculator() {
    const modal = document.getElementById('sizeCalculatorModal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
        resetCalculator();
    }
}

function resetCalculator() {
    // Reset alle Felder
    const fields = ['bust', 'waist', 'hip', 'height'];
    fields.forEach(field => {
        const element = document.getElementById(field);
        if (element) element.value = '';
    });
    
    const result = document.getElementById('result');
    if (result) {
        result.innerHTML = '';
        result.style.display = 'none';
    }
    
    // Reset category zu Damen
    currentCategory = 'women';
    updateCategoryTabs();
    updatePatternOptions();
    setDefaultHeight();
}

function initializeCalculator() {
    // Kategorie-Tabs setup
    updateCategoryTabs();
    updatePatternOptions();
    setDefaultHeight();
    
    // Event Listeners für Pattern-Change
    const patternSelect = document.getElementById('pattern');
    if (patternSelect) {
        patternSelect.addEventListener('change', updateBustFieldVisibility);
        updateBustFieldVisibility(); // Initial call
    }
}

// ===== KATEGORIE MANAGEMENT =====
function setCategory(category) {
    currentCategory = category;
    updateCategoryTabs();
    setDefaultHeight();
    
    // Clear result when switching categories
    const result = document.getElementById('result');
    if (result) {
        result.style.display = 'none';
    }
}

function updateCategoryTabs() {
    const tabs = document.querySelectorAll('.category-tab');
    tabs.forEach(tab => {
        tab.classList.remove('active');
        if (tab.textContent.toLowerCase().includes(currentCategory === 'women' ? 'damen' : 
                                                   currentCategory === 'men' ? 'herren' : 'kinder')) {
            tab.classList.add('active');
        }
    });
}

function updatePatternOptions() {
    // Pattern options bleiben gleich für alle Kategorien
    const patternSelect = document.getElementById('pattern');
    if (patternSelect && patternSelect.options.length === 0) {
        patternSelect.innerHTML = `
            <option value="top">Oberteil</option>
            <option value="pants">Hose</option>
            <option value="dress">Kleid</option>
            <option value="skirt">Rock</option>
        `;
    }
}

function setDefaultHeight() {
    const heightField = document.getElementById('height');
    if (heightField) {
        if (currentCategory === 'women') {
            heightField.value = 168;
        } else if (currentCategory === 'men') {
            heightField.value = 180;
        } else {
            heightField.value = '';
        }
    }
}

function updateBustFieldVisibility() {
    const pattern = document.getElementById('pattern')?.value;
    const bustGroup = document.getElementById('bustGroup');
    const bustField = document.getElementById('bust');
    
    if (bustGroup && bustField) {
        if (pattern === 'pants' || pattern === 'skirt') {
            bustGroup.style.display = 'none';
            bustField.removeAttribute('required');
        } else {
            bustGroup.style.display = 'block';
            bustField.setAttribute('required', 'required');
        }
    }
}

// ===== VALIDIERUNG =====
function validateInput(category, pattern, bust, waist, hip, height) {
    const ranges = {
        women: {
            bust: { min: 80, max: 172 },
            waist: { min: 64, max: 161 },
            hip: { min: 89, max: 174 },
            height: { min: 140, max: 200 }
        },
        men: {
            bust: { min: 86, max: 159 },
            waist: { min: 78, max: 154 },
            hip: { min: 93, max: 150 },
            height: { min: 150, max: 210 }
        },
        kids: {
            bust: { min: 46, max: 89 },
            waist: { min: 46, max: 79 },
            hip: { min: 47, max: 93 },
            height: { min: 72, max: 172 }
        }
    };

    const range = ranges[category];
    const errors = [];

    // Prüfe nur relevante Maße
    if (pattern !== 'pants' && pattern !== 'skirt') {
        if (bust < range.bust.min || bust > range.bust.max) {
            errors.push(`Brustumfang: ${range.bust.min}-${range.bust.max}cm`);
        }
    }
    
    if (waist < range.waist.min || waist > range.waist.max) {
        errors.push(`Taillenumfang: ${range.waist.min}-${range.waist.max}cm`);
    }
    
    if (hip < range.hip.min || hip > range.hip.max) {
        errors.push(`Hüftumfang: ${range.hip.min}-${range.hip.max}cm`);
    }
    
    if (height < range.height.min || height > range.height.max) {
        errors.push(`Körpergröße: ${range.height.min}-${range.height.max}cm`);
    }

    if (errors.length > 0) {
        return {
            valid: false,
            message: `Diese Werte liegen außerhalb unseres Größenangebots:<br><br>${errors.join('<br>')}<br><br>Bitte prüfen Sie Ihre Eingabe oder kontaktieren Sie uns für eine individuelle Beratung.`
        };
    }

    return { valid: true };
}

// ===== BERECHNUNGSLOGIK (AUS FUNKTIONIERENDEM HTML) =====
function findBestSize(table, measurement, type, tolerance) {
    console.log(`\n=== BERECHNUNG FÜR ${type.toUpperCase()} ===`);
    console.log(`Messwert: ${measurement}cm, Toleranz: ±${tolerance}cm`);
    
    // Schritt 1: Nächstliegende Größe finden
    let closest = null;
    let minDiff = Infinity;
    
    for (const size of table) {
        const diff = Math.abs(size[type] - measurement);
        if (diff < minDiff) {
            minDiff = diff;
            closest = size;
        }
    }
    
    const originalDiff = measurement - closest[type];
    console.log(`Nächste Größe: EU ${closest.eu} (${closest[type]}cm)`);
    console.log(`Abweichung: ${originalDiff >= 0 ? '+' : ''}${originalDiff.toFixed(1)}cm`);
    
    // Schritt 2: Toleranz prüfen
    if (Math.abs(originalDiff) <= tolerance) {
        console.log(`✅ INNERHALB TOLERANZ (±${tolerance}cm) - keine Anpassung`);
        return {
            finalSize: closest,
            originalSize: closest,
            adjusted: false,
            adjustedFor2Size: false,
            difference: originalDiff
        };
    }
    
    console.log(`❌ AUSSERHALB TOLERANZ - suche bessere Größe`);
    
    // Optimaler Komfort: Negative Abweichung besser als positive
    let best = closest;
    let bestDiff = originalDiff;
    
    console.log(`Prüfe alle Größen für optimalen Komfort:`);
    
    for (const size of table) {
        const sizeDiff = measurement - size[type];
        
        if (sizeDiff < 0 && bestDiff > 0) {
            // Negative ist IMMER besser als positive
            console.log(`EU ${size.eu}: ${sizeDiff.toFixed(1)}cm (zu weit) BESSER als ${bestDiff.toFixed(1)}cm (zu eng)`);
            best = size;
            bestDiff = sizeDiff;
        } else if (sizeDiff < 0 && bestDiff < 0) {
            // Beide negativ: weniger negativ ist besser
            if (Math.abs(sizeDiff) < Math.abs(bestDiff)) {
                console.log(`EU ${size.eu}: ${sizeDiff.toFixed(1)}cm näher zu 0 als ${bestDiff.toFixed(1)}cm`);
                best = size;
                bestDiff = sizeDiff;
            }
        } else if (sizeDiff > 0 && bestDiff > 0) {
            // Beide positiv: weniger positiv ist besser
            if (Math.abs(sizeDiff) < Math.abs(bestDiff)) {
                console.log(`EU ${size.eu}: ${sizeDiff.toFixed(1)}cm näher zu 0 als ${bestDiff.toFixed(1)}cm`);
                best = size;
                bestDiff = sizeDiff;
            }
        }
    }
    
    console.log(`✅ FINALE ENTSCHEIDUNG:`);
    console.log(`Beste Größe: EU ${best.eu} (${best[type]}cm)`);
    console.log(`Finale Abweichung: ${bestDiff >= 0 ? '+' : ''}${bestDiff.toFixed(1)}cm`);
    
    return {
        finalSize: best,
        originalSize: closest,
        adjusted: true,
        adjustedFor2Size: false,
        difference: bestDiff
    };
}

function apply2SizeRule(results, table) {
    console.log("\n=== 2-GRÖSSEN-REGEL ===");
    const sizes = Object.values(results).map(r => r.finalSize.eu);
    const min = Math.min(...sizes);
    const max = Math.max(...sizes);
    console.log(`Größen: ${sizes.join(', ')}`);
    console.log(`Min: EU ${min}, Max: EU ${max}, Unterschied: ${max - min} Punkte`);
    
    if (max - min > 4) {
        console.log("❌ MEHR ALS 2 EU-GRÖSSEN - Anpassung nötig");
        const allowedMin = max - 4;
        console.log(`Erlaubte Min-Größe: EU ${allowedMin}`);
        
        Object.keys(results).forEach(key => {
            if (results[key].finalSize.eu < allowedMin) {
                const newSize = table.find(s => s.eu === allowedMin);
                console.log(`${key}: EU ${results[key].finalSize.eu} → EU ${allowedMin}`);
                if (newSize) {
                    const originalOriginal = results[key].originalSize;
                    results[key] = {
                        finalSize: newSize,
                        originalSize: originalOriginal,
                        adjusted: results[key].adjusted,
                        adjustedFor2Size: true,
                        difference: measurements[key] - newSize[key]
                    };
                }
            }
        });
    } else {
        console.log("✅ MAXIMAL 2 EU-GRÖSSEN - keine Anpassung nötig");
    }
    
    return results;
}

// ===== HAUPTBERECHNUNG =====
function calculateSize() {
    console.log("Starte Berechnung mit korrigierter Toleranz-Logik");
    
    const bust = parseFloat(document.getElementById('bust')?.value);
    const waist = parseFloat(document.getElementById('waist')?.value);
    const hip = parseFloat(document.getElementById('hip')?.value);
    const height = parseFloat(document.getElementById('height')?.value);
    const category = currentCategory;
    const pattern = document.getElementById('pattern')?.value || 'top';

    // Basis-Validierung
    if (isNaN(waist) || isNaN(hip) || isNaN(height)) {
        showError('Bitte alle Werte eingeben');
        return;
    }

    if ((pattern !== 'pants' && pattern !== 'skirt') && isNaN(bust)) {
        showError('Brustumfang erforderlich für Oberteile und Kleider');
        return;
    }

    // Wertebereiche-Validierung
    const validation = validateInput(category, pattern, bust, waist, hip, height);
    if (!validation.valid) {
        showError(validation.message);
        return;
    }

    console.log(`Eingabe: ${category}, ${pattern}, BU: ${bust}cm, TU: ${waist}cm, HU: ${hip}cm, Größe: ${height}cm`);

    // Tabelle auswählen
    let table;
    let tolerance;
    let standard;
    
    if (category === 'women') {
        table = WOMEN_SIZES;
        tolerance = 1.6;
        standard = 168;
    } else if (category === 'men') {
        table = MEN_SIZES;
        tolerance = 1.6;
        standard = 180;
    } else {
        table = KIDS_SIZES;
        tolerance = 1.1;
        // Kinder: Körperlänge zur nächst höheren EU-Größe
        const nextSize = table.find(s => s.height >= height) || table[table.length - 1];
        standard = nextSize.height;
    }

    measurements = { bust: bust, waist: waist, hip: hip };
    let results = {};

    // Relevante Maße berechnen
    if (pattern !== 'pants' && pattern !== 'skirt') {
        results.bust = findBestSize(table, bust, 'bust', tolerance);
    }
    results.waist = findBestSize(table, waist, 'waist', tolerance);
    results.hip = findBestSize(table, hip, 'hip', tolerance);

    // 2-Größen-Regel anwenden
    results = apply2SizeRule(results, table);

    // Ausgabe generieren
    generateOutput(results, pattern, category, height, standard, measurements);
}

// ===== AUSGABE GENERIERUNG =====
function generateOutput(results, pattern, category, height, standard, measurements) {
    // Basis bestimmen
    let basisSize;
    let basisText;
    
    if (category === 'kids') {
        basisSize = standard;
        basisText = `EU ${standard} (für Körperlänge ${height}cm)`;
    } else if (pattern === 'pants' || pattern === 'skirt') {
        basisSize = results.hip.finalSize.eu;
        basisText = `EU ${basisSize} (basierend auf Hüftumfang)`;
    } else {
        basisSize = results.bust.finalSize.eu;
        basisText = `EU ${basisSize} (basierend auf Brustumfang)`;
    }

    const wasAdjusted = Object.values(results).some(r => r.adjustedFor2Size);
    if (wasAdjusted) {
        basisText = basisText.replace('(basierend auf', '(angepasst für sanfte Übergänge, basierend auf');
    }

    let html = `<div class="recommended"><h3>${category === 'kids' ? 'GRUNDGRÖSSE:' : 'EMPFOHLENE AUSGANGSGRÖSSE:'} ${basisText}</h3></div>`;

    const labels = { bust: 'Brustumfang', waist: 'Taillenumfang', hip: 'Hüftumfang' };

    Object.keys(results).forEach(key => {
        const result = results[key];
        const label = labels[key];
        const userMeasurement = measurements[key];

        let statusText = '';
        
        if (result.adjustedFor2Size) {
            statusText = `normalerweise EU ${result.originalSize.eu}, für sanfte Übergänge EU ${result.finalSize.eu}, Konstruktionsmaß EU ${result.finalSize.eu}: ${result.finalSize[key]}cm, ${result.difference >= 0 ? '+' : ''}${result.difference.toFixed(1)}cm Abweichung`;
        } else {
            statusText = `Konstruktionsmaß EU ${result.finalSize.eu}: ${result.finalSize[key]}cm, ${result.difference >= 0 ? '+' : ''}${result.difference.toFixed(1)}cm Abweichung`;
        }

        html += `
            <div class="size-detail">
                <strong>${label} entspricht: EU ${result.finalSize.eu}</strong><br>
                Ihr Maß: ${userMeasurement}cm, ${statusText}
            </div>
        `;
    });

    // Längenanpassung
    const lengthTolerance = category === 'kids' ? 1.1 : 3.1;
    const lengthDiff = height - standard;
    
    if (category === 'kids' && lengthDiff > lengthTolerance) {
        const newSize = KIDS_SIZES.find(s => s.height >= height);
        if (newSize) {
            html += `<div class="size-detail"><strong>Längenanpassung:</strong> Grundgröße angepasst auf EU ${newSize.height} für optimale Passform</div>`;
        }
    } else if (Math.abs(lengthDiff) > lengthTolerance) {
        const adjustment = pattern === 'dress' ? lengthDiff : lengthDiff / 2;
        const actionText = adjustment > 0 ? 'verlängern' : 'kürzen';
        html += `<div class="size-detail"><strong>Längenanpassung:</strong> ${Math.abs(adjustment).toFixed(1)}cm ${actionText} (Ihre Größe: ${height}cm, Standard: ${standard}cm)</div>`;
    } else {
        html += `<div class="size-detail"><strong>Längenanpassung:</strong> Keine Anpassung nötig (Ihre Größe: ${height}cm, Standard: ${standard}cm, ${lengthDiff >= 0 ? '+' : ''}${lengthDiff}cm innerhalb Toleranz)</div>`;
    }

    // Schrittanpassung bei Hosen
    if (pattern === 'pants') {
        html += `<div class="size-detail"><strong>Schrittanpassung:</strong> Für flachen oder runden Gesäß (Anleitung im E-Book)</div>`;
    }

    // Benötigte Größen
    const uniqueSizes = [...new Set(Object.values(results).map(r => r.finalSize.eu))].sort((a, b) => a - b);
    if (category === 'kids') {
        if (!uniqueSizes.includes(standard)) uniqueSizes.push(standard);
        uniqueSizes.sort((a, b) => a - b);
    }
    html += `<div class="size-detail"><strong>Benötigte Schnittmuster-Größen:</strong> ${uniqueSizes.map(s => `EU ${s}`).join(', ')}</div>`;

    // Anpassungstipps
    html += `<div class="size-detail"><strong>Anpassungstipps:</strong><br>`;
    
    if (category === 'kids') {
        html += `- Wählen Sie EU ${standard} als Grundgröße (Körperlänge-Basis)<br>`;
        if (uniqueSizes.length > 1) {
            const weitenSizes = uniqueSizes.filter(s => s !== standard);
            html += `- Blenden Sie zusätzlich ${weitenSizes.map(s => `EU ${s}`).join(' und ')} ein<br>`;
            html += `- Zeichnen Sie entsprechende Weitenlinien und sanfte Übergänge zur EU ${standard}-Längenlinie<br>`;
        }
    } else {
        if (pattern === 'pants' || pattern === 'skirt') {
            html += `- Bei ${pattern === 'pants' ? 'Hosen' : 'Röcken'} orientieren Sie sich an der Hüftgröße<br>`;
        } else {
            html += `- Bei ${pattern === 'dress' ? 'Kleidern' : 'Oberteilen'} orientieren Sie sich an der Brustgröße<br>`;
        }
        
        if (uniqueSizes.length > 1) {
            html += `- Zeichnen Sie gleitende Übergänge zwischen den Größen<br>`;
        }
    }
    
    html += `- Maximal 2 Größen in der Weite anpassen für sanfte Übergänge und optimale Passform<br>`;
    html += `- Bei mehr als 2 Größen Unterschied sind die Proportionen zu unterschiedlich<br>`;
    html += `- Detaillierte Anleitungen finden Sie in Ihrem E-Book</div>`;

    const result = document.getElementById('result');
    if (result) {
        result.innerHTML = html;
        result.style.display = 'block';
    }
}

function showError(message) {
    const result = document.getElementById('result');
    if (result) {
        result.innerHTML = `<div style="color: #dc3545; text-align: center; font-size: 16px; line-height: 1.5;">${message}</div>`;
        result.style.display = 'block';
    }
}

// ===== EVENT LISTENERS =====
// Modal schließen bei Klick außerhalb
window.onclick = function(event) {
    const modal = document.getElementById('sizeCalculatorModal');
    if (event.target == modal) {
        closeSizeCalculator();
    }
}

// DOMContentLoaded Event für Initialisierung
document.addEventListener('DOMContentLoaded', function() {
    console.log('Size Calculator loaded and ready');
});